import { GameConstants } from "../../../../GameConstants";
import * as Anuto from "../../../../../engine/src";
import { BoardContainer } from "../../board-container/BoardContainer";
import { GameVars } from "../../../../GameVars";

export class ArrowActor extends Phaser.GameObjects.Image {

    public anutoBullet: Anuto.Bullet;
    public initialPosition: {x: number, y: number};
    public realX: number;
    public realY: number;

    private hasImpacted: boolean;

    constructor(scene: Phaser.Scene, anutoBullet: Anuto.Bullet) {

        super(scene, 0, 0, "texture_atlas_2", "arrow" + (anutoBullet.turret.level === 1 ? "1" : "2"));

        this.anutoBullet = anutoBullet;

        this.setOrigin(0);
        this.visible = false;
        this.hasImpacted = false;

        this.x = this.anutoBullet.x * GameConstants.CELLS_SIZE;
        this.y = this.anutoBullet.y * GameConstants.CELLS_SIZE;

        this.realX = this.x;
        this.realY = this.y;

        this.initialPosition = {x: this.x, y: this.y};
    }

    public update(time: number, delta: number): void {

        if (this.hasImpacted) {

            this.scaleX *= .95;
            this.scaleY *= .7;

            if (this.scaleY < .1) {
                BoardContainer.currentInstance.removeArrowActor(this);
            }

        } else {
            let smoothFactor: number;

            if (GameConstants.INTERPOLATE_TRAJECTORIES) {
                smoothFactor = .3;
            } else {
                smoothFactor = 1;
            }
    
            let offX = (this.anutoBullet.x * GameConstants.CELLS_SIZE - this.realX) * smoothFactor;
            let offY = (this.anutoBullet.y * GameConstants.CELLS_SIZE - this.realY) * smoothFactor;
            
            this.realX += offX;
            this.realY += offY;
    
            this.rotation = Math.atan2(offY, offX) + Math.PI / 2;
    
            this.x = this.realX ;
            this.y = this.realY;
    
            if (!this.visible) {
                let distX = this.initialPosition.x - this.x;
                let distY = this.initialPosition.y - this.y;
                if (Math.sqrt( distX * distX + distY * distY) > 50) {
                    this.visible = true;
                }
            }
        }
    }

    public removeFromStage(): void {

        if (GameVars.timeStepFactor === 1) {
            this.hasImpacted = true;
        } else {
            BoardContainer.currentInstance.removeArrowActor(this);
        }
    }
}
